import * as React from "react"
import { useTimer } from "react-timer-hook"
import Img from "gatsby-image"
import Dots from "../images/dots.inline.svg"
import WomanSvg from "../images/fast.inline.svg"
import Workout from "../images/workout.inline.svg"
import Inspiration from "../images/inspiration.inline.svg"
import Slimming from "../images/slimming.inline.svg"
import Atmo from "../images/atmo.inline.svg"

const MyTimer = ({ expiryTimestamp }) => {
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn("onExpire called"),
  })

  return (
    <div className="countdown">
      <div className="countdown-timer">
        <div>дней</div>
        <div className="timer-name">{days}</div>
      </div>
      <div className="countdown-timer">
        <div>часов</div>
        <div className="timer-name">{hours}</div>
      </div>
      <div className="countdown-timer">
        <div>минут</div>
        <div className="timer-name">{minutes}</div>
      </div>
      <div className="countdown-timer">
        <div>секунд</div>
        <div className="timer-name">{seconds}</div>
      </div>
    </div>
  )
}

const HomeHeader = ({ imgData, workRef, isHeaderPlay }) => {
  const time = new Date("2021-02-01")

  return (
    <div id="header">
      <div className="header">
        <div className="container">
          <div className="w-layout-grid hero-grid">
            <div className="hero-content">
              <MyTimer expiryTimestamp={time} />
              <h1 className="display-h1">
                <span className="brand-span-dark">Фитнес проект</span>
                <br />
                для непокорных
              </h1>
              <div className="news-update">
                <WomanSvg className="update-icon" />
                <div style={{ marginTop: "10px" }}>
                  <span style={{ fontSize: "1.2em" }}>
                    Марафон стартует{" "}
                    <b style={{ color: "#ffff4f" }}>1 февраля</b>
                    <br />
                    <br />
                    <b>г. Гомель</b>, ул. Киселева 3В
                    <br />
                    <span style={{ display: "block", height: "5px" }} />
                    Расписание: Пн-Ср: <b>20-00</b>, Сб: <b>14-00</b>
                  </span>
                </div>
              </div>
              {/*<div className="news-sale">
                Cкидка <b>-30%</b> до <b>1 ноября</b>
              </div>*/}
              <div className="form-wrapper">
                <div className="news-block w-form">
                  <button
                    className="button button-form w-button"
                    onClick={() => {
                      workRef.current.scrollIntoView({ behavior: "smooth" })
                    }}
                  >
                    Узнать стоимость
                  </button>
                </div>
              </div>
              <blockquote>
                <p className="hero-paragraph">
                  Привет! Я фитнес тренер <b>Дарья Старикова</b> и я покорю тебя
                  с первого раза!
                </p>
              </blockquote>
            </div>
            <div className="hero-image-wrapper">
              <Dots className="dot-pattern" />
              <Img fluid={imgData} className="hero-person-wrapper" />
            </div>
          </div>
          <h4 style={{ margin: "40px 0", textAlign: "center" }}>
            Почему Вы должны выбрать меня?
          </h4>
          <ul className="w-layout-grid service-grid">
            <li>
              <Workout className="header-icon" />
              <span>Знания и опыт</span>
              <p>
                <b>10 летний</b> опыт в спорте и фитнесе. От{" "}
                <b>чемпионки Беларуси</b> по бегу до фитнес тренера с
                международным дипломом от авторитетного колледжа{" "}
                <b>им. Бена Вейдера</b>.
              </p>
            </li>
            <li>
              <Slimming className="header-icon" />
              <span>Знаю секрет идеального похудения</span>
              <p>
                Разработала <b>авторскую</b> программу <b>тренировок</b> и{" "}
                <b>питания</b>. Специальную <b>методику</b> и <b>систему</b>,
                для лучшего результата.
              </p>
            </li>
            <li>
              <Atmo className="header-icon" />
              <span>Создаю уютную и дружную атмосферу</span>
              <p>
                <b>Поддержка</b> команды и <b>чувство</b> соперничества взбодрит
                и не даст Вам сдаться.
              </p>
            </li>
            <li>
              <Inspiration className="header-icon" />
              <span>Умею вдохновлять и мотивировать</span>
              <p>
                Благодаря <b>любви</b> к своему <b>делу</b>, полной отдаче и
                работе на результат.
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div className="line-break"></div>
    </div>
  )
}

export default HomeHeader
